



































































































































































































































































































































































import { isEmptyObject } from '@/utils/helpers';
import props from './common/props';

import { Session } from '@/models/session';
import { Name } from '@/models/name';
import { FormRules } from '@/mixins/FormRules';
import { mapState } from 'vuex';

import Vue from 'vue';
import { Sponsor } from '@/models/sponsor';
import { sync } from 'vuex-pathify';

const DEFAULT_SPONSOR = Object.freeze({
  sponsor: {
    name: '',
    logo: '' as string | File,
    label: '',
    email: '',
    phone: '',
    url: '',
    social: {
      facebook: '',
      instagram: '',
      linkedin: '',
      twitter: '',
      youtube: ''
    },
    address: {
      address1: '',
      address2: '',
      region: '',
      postal_code: '',
      country: {
        name: ''
      }
    },
    created_at: '' as Date | string,
    updated_at: '' as Date | string
  } as Sponsor
});
export default Vue.extend({
  name: 'DataSponsorCreateCard',
  mixins: [FormRules],
  props: {
    ...props.base,
    categories: props.detail.categories,
    options: props.detail.options,
    create: props.functions.save
  },
  data: () => ({
    show: false,
    valid: false,

    optionsLoading: false,
    // updateSpeaker: {} as Speaker,
    defaultSponsor: DEFAULT_SPONSOR,
    sponsor: {
      name: '',
      logo: '' as string | File,
      label: '',
      email: '',
      phone: '',
      url: '',
      event: localStorage.getItem('current__event'),
      social: {
        facebook: '',
        instagram: '',
        linkedin: '',
        twitter: '',
        youtube: ''
      },
      address: {
        address1: '',
        address2: '',
        region: '',
        postal_code: '',
        country: {
          name: ''
        }
      },
      // sessions: null as null | number[] | Session[],
      created_at: '' as Date | string,
      updated_at: '' as Date | string
    } as Sponsor,
    itemsAdded: 0 as number,
    itemImage: null as any,
    rightDrawer: false
  }),
  computed: {
    ...mapState({
      sponsorError: (state: any) => state.sponsors.error
    })
    // rightDrawer: sync('app/rightDrawer')
  },
  methods: {
    isEmptyObject,
    onChange(e: any): void {
      try {
        const reader = new FileReader();
        const files = e.target.files || e.dataTransfer.files;
        this.itemsAdded = files.length;
        reader.onload = (e: ProgressEvent<FileReader>) => {
          this.itemImage = e.target?.result;
        };
        reader.readAsDataURL(files[0]);
        this.sponsor.logo = files[0];
      } catch (e) {
        console.log(e);
      }
    }
  }
});
